<template>
  <PrintPageLandscape>
    <PresentationPage :page-number="pageNumber" :page-count="pageCount">
      <p class="presentation-page__eyebrow">B2B · Gewerbe &amp; Großprojekte</p>

      <h2 class="presentation-page__title">
        Gewerbe &amp; Großprojekte — von 100 kWp bis Multi-MW
      </h2>

      <p class="presentation-page__text">
        EPC-Komplettleistung für Hallen, Quartiere und Freiflächen. Bankfähig dokumentiert,
        terminsicher umgesetzt.
      </p>

      <div class="presentation-page__group-cards">
        <article v-for="card in cards" :key="card.header" class="presentation-page__group-card">
          <div
            :class="[
              'presentation-page__group-card-header',
              `presentation-page__group-card-header--${card.accent}`,
            ]"
          >
            {{ card.header }}
          </div>

          <div
            class="presentation-page__group-card-body presentation-page__group-card-body--extended"
          >
            <div class="presentation-page__group-card-title-row">
              <h3 class="presentation-page__group-card-title">{{ card.title }}</h3>
              <div class="presentation-page__group-card-title-icon" aria-hidden="true">
                <i :class="['fa', card.icon]"></i>
              </div>
            </div>

            <p class="presentation-page__group-card-text">{{ card.text }}</p>

            <div class="presentation-page__group-card-accent" aria-hidden="true"></div>

            <ul class="presentation-page__list">
              <li v-for="item in card.items" :key="item">{{ item }}</li>
            </ul>
          </div>
        </article>
      </div>

      <p class="presentation-page__caption">
        Eigene Projektentwicklung · Bankfähige Dokumentation · 20 Jahre O&amp;M
      </p>
    </PresentationPage>
  </PrintPageLandscape>
</template>

<script>
import PrintPageLandscape from '@/components/Print/PrintPageLandscape.vue';
import PresentationPage from '@/views/MasterPresentation/PresentationPage';

export default {
  name: 'MasterPresentationPrintPage14',

  components: {
    PrintPageLandscape,
    PresentationPage,
  },

  props: {
    project: { type: Object, default: null },
    pageCount: { type: Number, default: null },
    pageNumber: { type: Number, default: 0 },
  },

  data() {
    return {
      cards: [
        {
          header: 'Hallendächer',
          accent: 'brand-primary',
          icon: 'fa-industry',
          title: 'Hallendächer und Industrieareale',
          text:
            'Logistik-, Produktions- und Lagerhallen ab 500 m². Pacht- oder Eigeninvestmodelle, mit oder ohne Eigenverbrauch. Statikprüfung und Ertragsgutachten inklusive.',
          items: ['100 kWp – 5 MWp', 'Pacht- und PPA-Modelle', 'Statik & Gutachten inklusive'],
        },
        {
          header: 'Wohnungsbau',
          accent: 'brand-secondary',
          icon: 'fa-building',
          title: 'Wohnanlagen und Quartierslösungen',
          text:
            'Mieterstrom für MFH, Genossenschaften und Bauträger. Vollständige Abrechnung über RETIS, ESG-konformer Zusatzerlös ohne Aufwand für den Eigentümer.',
          items: ['Mieterstrom turnkey', 'Auto. Abrechnung', 'ESG-konform & förderfähig'],
        },
        {
          header: 'Freifläche & BESS',
          accent: 'brand-teal',
          icon: 'fa-th',
          title: 'Freiflächenanlagen mit MW-Skalierung',
          text:
            'End-to-End-Projektentwicklung von der Flächensicherung bis zur Inbetriebnahme. PV, BESS und hybride Systeme inklusive Mittel- und Hochspannungs-Umspannwerke.',
          items: ['Ab 5 MWp aufwärts', 'PV + BESS hybrid', 'Inkl. Netzanschluss MS/HS'],
        },
      ],
    };
  },
};
</script>
